module.exports = __webpack_public_path__ + "static/media/55_000007.37cce442.jpg";